<template>
  <div>
    <Preloader v-if="isLoading"/>
    <h3 class="title montserrat-semibold">Recibe nuestras promociones exclusivas</h3>
    <form @submit.prevent="suscribirse" class="form d-flex align-items-center gap-4">
    <input type="email" v-model="correo" required class="form-control" placeholder="Ingrese su correo" />
    <input type="submit" value="Suscribirme" class="btn rounded-pill montserrat-semibold" />
    </form>
    <span class="message">Al suscribirme acepto la <strong class="montserrat-semibold">política de protección de datos</strong></span>
    <div class="thank-you-register" id="thankYouRegister" v-if="showThankYou">
      <div class="thank-you-register__content">
        <button class="button-close" type="button" id="thankYouRegisterClose" @click="showThankYou = false">
          <i class="bi bi-x-lg"></i>
        </button>
        <img src="@/assets/catalogo/img/thank-you-register-image.png" alt="" class="image mb-4" />
        <h3 class="title montserrat-bold mb-4">{{ title }}</h3>
        <div class="text montserrat-semibold">
          <p>
           {{ text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { RegistrarService } from '@/services/RegistrarService'
export default {
  props: {
    tipoSuscripcion: String
  },
  data () {
    return {
      registrarService: new RegistrarService(),
      correo: '',
      error: {
        show: false,
        message: ''
      },
      showThankYou: false,
      title: '',
      text: 'Pronto nuestros asesores se comunicarán contigo para brindarte la asistencia que necesitas.'
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      isLoading: state => state.loading.isLoading,
      isLoggedIn: state => state.user.isLoggedIn
    })
  },
  methods: {
    async suscribirse () {
      if (!this.isLoggedIn) {
        this.$router.push('/login')
        return
      }
      if (!this.correo) {
        this.error.show = true
        this.error.message = 'Por favor, ingresa tu correo.'

        setTimeout(() => {
          this.error.show = false
        }, 5000)

        return
      }
      await this.registrarService.suscribirse({ correo: this.correo, codCliente: this.user.codCliente, tipoSuscripcion: this.tipoSuscripcion }).then(response => {
        if (response.statusCode === 200) {
          this.title = ''
          this.text = 'Suscripción registrada correctamente.'
          this.correo = ''
        } else {
          this.title = ''
          this.text = 'Ups, hubo un error.'
        }
      }).catch(error => {
        console.log(error)
        this.title = ''
        this.text = 'Ups, hubo un error.'
      })
      this.showThankYou = true
    }
  }
}
</script>
